<template>
  <v-card class="mb-4 class-item-tile" :id="customClass.id">
    <v-card-text>
      <v-row justify="space-between">
        <v-col lg="5" md="5" cols="12" sm="6">
          <h2 class="headline">
            {{ customClass.name }}
          </h2>
          <h3 class="pb-4">{{ yearLevel }}</h3>
        </v-col>
        <v-col lg="7" md="7" cols="12" sm="6">
          <div class="text-left text-sm-right sm:mt-2">
            <p class="class-tile-text">
              <span>
                <!-- <v-icon small>person</v-icon> -->
                {{ customClass.students_number }}
                students enrolled in the class
              </span>
              <br />
              <!-- <v-icon small>import_contacts</v-icon> -->
              {{ customClass.lessons ? customClass.lessons.length : 0 }}
              {{ customClass.lessons === 1 ? lessonTerm : `${lessonTerm}s` }}
              activated
            </p>
          </div>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-card-actions class="class-item-action">
            <v-spacer />
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click="classTileClick('edit')"
                  :class="[
                    'class-item-button',
                    {
                      activeButton:
                        currentParentTab == 'edit' &&
                        currentClassId === customClass.id
                    }
                  ]"
                  :dark="
                    currentParentTab == 'edit' &&
                    currentClassId === customClass.id
                      ? true
                      : false
                  "
                >
                  <v-icon left>create</v-icon> edit
                </v-btn>
              </template>
              <span>Edit your class name and year level</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click="classTileClick('announcement')"
                  :class="[
                    'class-item-button',
                    {
                      activeButton:
                        currentParentTab == 'announcement' &&
                        currentClassId === customClass.id
                    }
                  ]"
                  :dark="
                    currentParentTab == 'announcement' &&
                    currentClassId === customClass.id
                      ? true
                      : false
                  "
                >
                  <v-icon left>announcement</v-icon> announcements
                </v-btn>
              </template>
              <span>
                Make an annoucement to your class or edit existing ones
              </span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click="classTileClick('students')"
                  :class="[
                    'class-item-button',
                    {
                      activeButton:
                        currentParentTab == 'students' &&
                        currentClassId === customClass.id
                    }
                  ]"
                  :dark="
                    currentParentTab == 'students' &&
                    currentClassId === customClass.id
                      ? true
                      : false
                  "
                >
                  <v-icon left>people</v-icon> students
                </v-btn>
              </template>
              <span>
                Add new students or update their details
              </span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click="classTileClick('lessons')"
                  :class="[
                    'class-item-button',
                    {
                      activeButton:
                        currentParentTab == 'lessons' &&
                        currentClassId === customClass.id
                    }
                  ]"
                  :dark="
                    currentParentTab == 'lessons' &&
                    currentClassId === customClass.id
                      ? true
                      : false
                  "
                >
                  <v-icon left>class</v-icon>{{ `${lessonTerm}s` }}
                </v-btn>
              </template>
              <span>
                Add or remove new {{ lessonTerm }}s for your class to work on
              </span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click="classTileClick('reports')"
                  :class="[
                    'class-item-button',
                    {
                      activeButton:
                        currentParentTab == 'reports' &&
                        currentClassId === customClass.id
                    }
                  ]"
                  :dark="
                    currentParentTab == 'reports' &&
                    currentClassId === customClass.id
                      ? true
                      : false
                  "
                >
                  <v-icon left>pie_chart</v-icon> reports
                </v-btn>
              </template>
              <span>
                See how your class is doing
              </span>
            </v-tooltip>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-card-text>

    <v-slide-y-transition color="#000000">
      <div
        v-if="currentParentTab == 'edit' && currentClassId === customClass.id"
      >
        <edit-class
          ref="edit"
          :customClass="customClass"
          @close-tab="closeTab"
        />
      </div>
      <div
        v-if="
          currentParentTab == 'announcement' &&
            currentClassId === customClass.id
        "
      >
        <create-edit-announcements ref="announcement" @close-tab="closeTab" />
      </div>
      <div
        v-else-if="
          currentParentTab == 'students' && currentClassId === customClass.id
        "
      >
        <manage-students
          ref="students"
          :customClass="customClass"
          @close-tab="closeTab"
        />
      </div>
      <div
        v-else-if="
          currentParentTab == 'lessons' && currentClassId === customClass.id
        "
      >
        <manage-lesson
          ref="lessons"
          @close-tab="closeTab"
          :currentClassId="customClass.id"
          :selectedLessons="customClass.lessons"
        />
      </div>
      <div
        v-else-if="
          currentParentTab == 'reports' && currentClassId === customClass.id
        "
      >
        <class-report
          ref="reports"
          @close-tab="closeTab"
          :customClass="customClass"
        />
      </div>
    </v-slide-y-transition>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import EditClass from './edit/EditClass'
import CreateEditAnnouncements from './announcements/CreateEditAnnouncements'
import ManageStudents from './manage_students/ManageStudents'
import ManageLesson from './manage_lessons/ManageLesson'
import ClassReport from './report/ClassReport'
import Auth from '@/modules/auth/models/Auth'
import Class from '@/modules/class/models/Class'

export default {
  name: 'ClassItem',
  components: {
    CreateEditAnnouncements,
    ManageStudents,
    ManageLesson,
    EditClass,
    ClassReport
  },
  props: {
    customClass: {
      type: Object,
      require: true
    },
    isExpandable: {
      type: Boolean,
      default: true,
      require: false
    }
  },
  data() {
    return {
      disableExpand: true,
      newClass: false,
      currentParentTab: null,
      activeChild: null
    }
  },
  watch: {
    isExpandable(val) {
      if (!val) {
        this.currentParentTab = null
      }
    }
  },
  mounted() {
    this.currentParentTab = this.$route.query.currentParentTab
  },
  computed: {
    ...mapState(['lessonTerm']),
    ...mapGetters('entities/classes', ['currentClassId']),
    schoolName() {
      const authTeacher = Auth.query().first()

      if (!authTeacher) return ''

      return `${authTeacher.school_name}`
    },
    yearLevel() {
      let yls = this.customClass.year_levels
      if (!yls) return ''

      if (yls.length) {
        return yls[0].name
      } else {
        return ''
      }
    }
  },
  methods: {
    async setCurrentClassId() {
      await Class.dispatch('setCurrent', this.customClass.id)
    },
    classTileClick(type) {
      if (this.currentClassId === this.customClass.id) {
        if (this.currentParentTab == type) {
          this.currentParentTab = null
        } else {
          this.currentParentTab = type
        }
      } else {
        this.currentParentTab = type
        this.setCurrentClassId()
      }
      this.$emit('expand')
      this.setQuery()
    },
    setActive(v) {
      if (v === 'add-new-students') {
        this.currentParentTab = 'students'
        this.$nextTick(() => {
          // this.$refs.manageStudent.currentParentTab = 1
        })
      }
    },
    closeTab() {
      this.currentParentTab = null
      this.setQuery()
    },
    setQuery() {
      let query = Object.assign({}, this.$route.query)

      if (this.currentParentTab != null) {
        query.currentClassId = this.currentClassId
        query.currentParentTab = this.currentParentTab
        delete query.create
      } else {
        delete query.currentClassId
        delete query.currentParentTab
        delete query.currentChildTab
      }
      this.$router.push({ query: query })
    }
  }
}
</script>

<style lang="scss">
.class-item-tile {
  overflow: hidden;

  .close-button {
    position: absolute;
    right: 20px;
    top: 12px;
  }

  .band {
    background: var(--v-primary-base);
    height: 72px;
  }

  .class-item-action {
    @include breakpoint($sm) {
      display: block;
    }
  }
  .class-item-button {
    margin-left: 15px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;

    @include breakpoint($sm) {
      display: block;
      width: 100%;
      margin-left: 0 !important;
      margin-top: 15px;
    }
    &.activeButton {
      background: var(--v-primary-base) !important;
      box-shadow: none !important;
      // height: 65px;
      // margin-bottom: -26px;

      &:after {
        content: '';
        position: absolute;
        bottom: -25px;
        height: 25px;
        left: 0;
        right: 0;
        background: var(--v-primary-base);
        box-shadow: none;
      }

      @include breakpoint($sm) {
        margin: 0;
        margin-top: 15px;
        height: 36px;
        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
          0px 2px 2px 0px rgba(0, 0, 0, 0.14),
          0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
      }
    }
  }
}
</style>
